import { useQueryClient } from 'react-query';
import { getGenerateSummaryQueryKey } from '../queries';

export const useInvalidateGenerateSummary = () => {
  const queryClient = useQueryClient();

  const invalidateGenerateSummary = (params: { mediaId: string; locationId: string; faxId: string }) => {
    queryClient.invalidateQueries(getGenerateSummaryQueryKey(params));
  };

  return invalidateGenerateSummary;
};
